import { Component } from 'react';

/**
 * Lo que se ve cuando un componente se rompe al dibujarse.
 *
 * **Por qué existe.** Hasta el 2026-08-25 la aplicación **no tenía ninguno**, así que un error de
 * renderizado en cualquier parte borraba la pantalla entera y no dejaba rastro: ni qué componente,
 * ni qué error, ni cómo volver. A Diego le pasó dos veces en un día —una en *Mis solicitudes*, otra
 * al ensayar un agente— y las dos veces el síntoma fue el mismo: blanco.
 *
 * **Una pantalla en blanco es la peor forma de fallar de una interfaz.** No dice qué pasó, no dice
 * si se perdió algo, y no deja seguir trabajando en lo demás. Un cartel acotado deja el resto de
 * la aplicación en pie y dice qué se rompió.
 *
 * **Y deja el error a la vista, no sólo en la consola.** Quien lo reporta casi nunca tiene la
 * consola abierta; si el mensaje no está en la pantalla, se pierde — y con él la única pista.
 */
export default class SiAlgoSeRompe extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // Queda en la consola para quien la tenga abierta, **además** de en pantalla.
    console.error('se rompió al dibujar:', error, info?.componentStack);
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;

    return (
      <div className="p-4" data-testid="algo-se-rompio">
        <div className="border border-red-200 bg-red-50 rounded-sm p-4 max-w-2xl space-y-2">
          <p className="text-sm font-semibold text-red-900">
            Se rompió {this.props.donde ? `«${this.props.donde}»` : 'esta parte de la pantalla'}
          </p>
          <p className="text-[11px] text-red-800">
            El resto de la aplicación sigue funcionando: podés navegar a otra sección. Lo que
            estabas viendo no se guardó ni se perdió — no llegó a dibujarse.
          </p>
          <pre className="text-[10px] bg-white border border-red-200 rounded-sm p-2 overflow-x-auto max-h-40 text-red-900">
{String(error?.message || error)}
          </pre>
          <button
            type="button"
            onClick={() => this.setState({ error: null })}
            className="text-[11px] text-red-900 underline"
          >
            Intentar dibujarlo de nuevo
          </button>
        </div>
      </div>
    );
  }
}
